import React from 'react'

const AccessDenied = () => (
  <div class="text-center" style={{ paddingTop: '32px' }}>
    <h1>Acceso denegado</h1>
    <p>No tiene los permisos necesarios para acceder a esta página.</p>
  </div>
)

export default AccessDenied
